
import { Tooltip } from 'element-ui'

export default {
  extends: Tooltip,
}
